module.exports = __webpack_public_path__ + "assets/img/086101.e4a27f5d.png";